import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Label, TextInput, Card } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaDeteccionRiesgosInterface } from "../../../../../interfaces/FechaDeteccionRiesgosInterface";
import { SemaforoDRInterface } from "../../../../../interfaces/SemaforoDRInterface";
import { NotasConclusionDRInterface } from "../../../../../interfaces/NotasConclusionDRInterface";
import { ResultadoDRInterface } from "../../../../../interfaces/ResultadoDRInterface";
import fotoMapa from "../../../../../img/fotoMapa.png";

export const ConclusionesDRListaPrint = () => {
  const tituloFormulario = "CONCLUSIONES DE EVALUACIÓN DE DETECCIÓN DE RIESGOS";
  const { control, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const formFields = [
    { label: "NOMBRE:", id: "nombre" },
    { label: "DOMICILIO:", id: "domicilio" },
    { label: "TELÉFONO:", id: "telefono" },
    { label: "OCUPACIÓN:", id: "ocupacion" },
    { label: "AÑOS DE CONOCER AL EVALUADO:", id: "anios-conocerlo" },
    { label: "COMENTARIOS:", id: "comentarios" },
    { label: "LO RECOMIENDA:", id: "como-conoce" },
  ];

  const [formData, setFormData] = useState({});

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechaDeteccionRiesgosInterface>({
    url: `/fecha-deteccion-riesgos/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha-deteccion-riesgos"],
  });

  const queryNotasDR = useGetData<NotasConclusionDRInterface[]>({
    url: `/notas-conclusion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "notas-conclusion"],
  });

  const queryResultadoDR = useGetData<ResultadoDRInterface[]>({
    url: `/resultado-conclusion/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "resultado-conclusion"],
  });

  const querySemaforoDR = useGetData<SemaforoDRInterface>({
    url: `/semaforoDR/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "semaforoDR"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  useEffect(() => {
    console.log(queryEvaluado.data);
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: queryEvaluado.data.fecha_nacimiento || "",
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
            console.log("URL de la foto:", data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  useEffect(() => {
    if (queryFecha.data) {
      reset({
        fecha_conclusionesdr: queryFecha.data.fecha_conclusionesdr || "",
        evaluado_uuid: queryFecha.data.evaluado_uuid || "",
      });
    }
  }, [queryFecha.data, reset]);

  useEffect(() => {
    if (queryNotasDR.data && queryNotasDR.data.length > 0) {
      const notadr = queryNotasDR.data[0];
      reset({
        nota_conclusion: notadr.nota_conclusion || "",
        evaluado_uuid: notadr.evaluado_uuid || "",
      });
    }
  }, [queryNotasDR.data, reset]);

  useEffect(() => {
    if (queryResultadoDR.data && queryResultadoDR.data.length > 0) {
      const resultadodr = queryResultadoDR.data[0];
      reset({
        resultado_conclusion: resultadodr.resultado_conclusion || "",
        evaluado_uuid: resultadodr.evaluado_uuid || "",
      });
    }
  }, [queryNotasDR.data, reset]);

  useEffect(() => {
    if (querySemaforoDR.data) {
      const color = querySemaforoDR.data.color_dr || "";

      let recommendation = "";
      if (color === "verde") {
        recommendation = "recomendable";
      } else if (color === "amarillo") {
        recommendation = "con_reserva";
      } else if (color === "rojo") {
        recommendation = "no_recomendable";
      }

      reset({
        color_dr: color,
        evaluado_uuid: querySemaforoDR.data.evaluado_uuid || "",
      });

      setSelectedRecommendation(recommendation);

      if (recommendation === "recomendable") {
        setSelectedImage(Verde);
      } else if (recommendation === "con_reserva") {
        setSelectedImage(Amarillo);
      } else if (recommendation === "no_recomendable") {
        setSelectedImage(Rojo);
      }
    }
  }, [querySemaforoDR.data, reset]);

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario}/>
      {/* Título del formulario */}
      <div
        id="headerContent"
        className="text-center"
      >
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA EVALUACIÓN:
            </Label>
            <Controller
              name="fecha_conclusionesdr"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_conclusionesdr"
                  type="date"
                  value={queryFecha.data?.fecha_conclusionesdr}
                  className="w-32"
                  disabled={true}
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* FOTO */}
          <div className="w-40 h-40 border border-gray-300 rounded-md overflow-hidden bg-gray-100 flex items-center justify-center mt-4 relative z-10">
            {photoUrl ? (
              <img
                src={photoUrl}
                alt="Foto de evaluado"
                className="w-full h-full object-cover"
              />
            ) : (
              <span className="text-gray-500">Sin foto disponible</span>
            )}
          </div>
          {/* SEMAFORO */}
          <div className="flex items-center gap-4">
            {/* Radio buttons */}
            <div className="flex flex-col">
              <label className="flex items-center gap-2 mt-4 mb-4">
                <input
                  type="radio"
                  name="recommendation"
                  value="recomendable"
                  checked={selectedRecommendation === "recomendable"}
                  onChange={handleRadioChange}
                />
                RECOMENDABLE
              </label>
              <label className="flex items-center gap-2 mt-12 mb-12">
                <input
                  type="radio"
                  name="recommendation"
                  value="con_reserva"
                  checked={selectedRecommendation === "con_reserva"}
                  onChange={handleRadioChange}
                />
                CON RESERVA
              </label>
              <label className="flex items-center gap-2 mb-12">
                <input
                  type="radio"
                  name="recommendation"
                  value="no_recomendable"
                  checked={selectedRecommendation === "no_recomendable"}
                  onChange={handleRadioChange}
                />
                NO RECOMENDABLE
              </label>
            </div>
            {/* Imagen de Semaforo */}
            <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-[200px]"></div>
      <div className="flex justify-center items-center">
        <div className="bg-slate-100 rounded-lg w-full max-w-4xl">
          <h1 className="text-center text-xl font-semibold text-gray-800">
            CONCLUSIONES DE EVALUACIÓN DE DETECCIÓN DE RIESGOS
          </h1>
        </div>
      </div>

      {/* Sección de Notas */}
      <div className="border border-gray-300">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <Controller
          name="nota_conclusion"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              id="nota_conclusion"
              value={
                field.value ||
                (queryNotasDR.data && queryNotasDR.data.length > 0
                  ? queryNotasDR.data[0]?.nota_conclusion || ""
                  : "")
              }
              onChange={(e) => field.onChange(e.target.value)}
              className="w-full p-2 min-h-[725px] text-sm text-gray-900 border-0 focus:ring-0"
              disabled={true}
            />
          )}
        />
      </div>
      <div className="grid grid-cols-2 gap-2">
        {/* FIRMA REALIZÓ */}
        <div className="col-span-1">
          <Label htmlFor="FirmaRealizo">FIRMA REALIZÓ:</Label>
          <TextInput id="FirmaRealizo" name="FirmaRealizo" disabled={true} />
        </div>
        {/* FIRMA REVISÓ */}
        <div className="col-span-1">
          <Label htmlFor="FirmaReviso">FIRMA REVISÓ:</Label>
          <TextInput id="FirmaReviso" name="FirmaReviso" disabled={true} />
        </div>
        {/* FIRMA REALIZÓ */}
        <div className="col-span-1">
          <Label htmlFor="resultado">RESULTADO:</Label>
          <Controller
            name="resultado_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="resultado_conclusion"
                type="text"
                value={
                  field.value ||
                  (queryResultadoDR.data && queryResultadoDR.data.length > 0
                    ? queryResultadoDR.data[0]?.resultado_conclusion || ""
                    : "")
                }
                onChange={(e) => field.onChange(e.target.value)}
                disabled={true}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};
